import { render, staticRenderFns } from "./checkMoreNews.vue?vue&type=template&id=e418dbe8&scoped=true&"
import script from "./checkMoreNews.vue?vue&type=script&lang=ts&"
export * from "./checkMoreNews.vue?vue&type=script&lang=ts&"
import style0 from "./checkMoreNews.vue?vue&type=style&index=0&id=e418dbe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e418dbe8",
  null
  
)

export default component.exports